"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ButtonGroup.css");
var _layout = require("../layout");
var _linaria = require("../utils/linaria");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const list = "cds-list-l1g04p8d";
const item = "cds-item-izghyk0";
const fill = "cds-fill-f1phdnyk";
const ButtonGroup = /*#__PURE__*/(0, _react.memo)(function ButtonGroup({
  accessibilityLabel,
  block,
  children,
  testID,
  direction
}) {
  const isVertical = direction === 'vertical';
  const Stack = isVertical ? _layout.VStack : _layout.HStack;
  return /*#__PURE__*/_react.default.createElement(Stack, {
    alignItems: "stretch",
    "aria-label": accessibilityLabel,
    as: "ul",
    className: list,
    flexWrap: "nowrap",
    gap: 1,
    testID: testID
  }, _react.Children.map(children, child => child ? /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _linaria.cx)(item, block && fill)
  }, /*#__PURE__*/(0, _react.cloneElement)(child, {
    block: block || isVertical
  })) : null));
});
exports.ButtonGroup = ButtonGroup;